import { paletteHelper, spacingHelper, typographyHelper } from '@property.com.au/ui-kit';
import type { FunctionComponent } from 'react';
import styled, { css } from 'styled-components';
import type { PropertyTimelineEventProps } from '../PropertyTimelineEvent/PropertyTimelineEvent';
import { PropertyTimelineEvent } from '../PropertyTimelineEvent/PropertyTimelineEvent';

export const timelineDateColumnWidth = '64';
const badgeVerticalPadding = '5';

const Marker = styled.div`
  align-items: center;
  background-color: ${paletteHelper('backgroundPrimaryBase')};
  display: flex;
  height: calc(${spacingHelper('medium')} + ${spacingHelper('twoExtraSmall')});
  position: relative;
  top: -${spacingHelper('twoExtraSmall')};

  &::before {
    content: ' ';
    display: block;
    background-color: ${paletteHelper('textSecondary')};
    width: ${spacingHelper('extraSmall')};
    height: ${spacingHelper('extraSmall')};
    margin-left: ${spacingHelper('small')};
    border: 2px solid ${paletteHelper('backgroundPrimaryBase')};
    border-radius: 50px;
    box-shadow: 0 0 0 2px ${paletteHelper('borderPrimary')};
  }
`;

const LabelText = styled.time<{ $firstOfGroup: boolean }>`
  ${typographyHelper('overline')};
  color: ${paletteHelper('textPrimary')};

  /* still want to render in html for accessibility */
  ${({ $firstOfGroup }) =>
    !$firstOfGroup &&
    css`
      display: none;
    `}
`;

export const TimelineEventWrapper = styled.div`
  display: flex;
  flex-direction: row;

  position: relative;
  z-index: 2;
`;

const EventLabelWrapper = styled.div`
  width: ${timelineDateColumnWidth}px;
  flex-shrink: 0;
`;

const EventTimeWrapper = styled.span`
  width: ${timelineDateColumnWidth}px;
  display: flex;
  flex-direction: row;
  flex: 0 0 ${timelineDateColumnWidth}px;
  position: relative;
  top: ${badgeVerticalPadding}px;
  justify-content: flex-end;
`;

export const EventDetailsWrapper = styled.div`
  margin-left: ${spacingHelper('medium')};
  width: 100%;

  > * {
    margin-bottom: ${spacingHelper('extraLarge')};
  }
`;

export interface PropertyTimelineEventGroupProps {
  label: string;
  events: PropertyTimelineEventProps[];
}

export const PropertyTimelineEventGroup: FunctionComponent<PropertyTimelineEventGroupProps> = ({
  label,
  events,
}) => {
  return (
    <>
      {events.map((event, index) => (
        <TimelineEventWrapper key={event.details || index}>
          <EventLabelWrapper>
            <EventTimeWrapper>
              <LabelText dateTime={label} $firstOfGroup={index === 0}>
                {label}
              </LabelText>
              <Marker />
            </EventTimeWrapper>
          </EventLabelWrapper>
          <EventDetailsWrapper>
            <PropertyTimelineEvent {...event} />
          </EventDetailsWrapper>
        </TimelineEventWrapper>
      ))}
    </>
  );
};
